import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService  {

 public  jwtHelperService = new JwtHelperService();
 
  constructor(public auth: AuthService, public router: Router) { }

  public canActivate(): boolean {
    const accessToken = localStorage.getItem('accessToken');
    const isExpired = this.jwtHelperService.isTokenExpired(accessToken);
    const canActivate = this.auth.isAuthenticated(accessToken) || !isExpired;
    if (!canActivate)  {
      this.router.navigate(['/login']);
      return false;
    }
    return canActivate;
  }

}
